import { ProjectType, ProjectTypes } from '../../../common/constants'
import API from '../../api'
import { NewJobRequest, NewJobResponse } from './newJobModel'

const getPath = (projectType: ProjectType) => {
  if (projectType === ProjectTypes.Maintenance) {
    return '/maintenance/create'
  }
  if (projectType === ProjectTypes.Ticket) {
    return '/tickets/create'
  }
  return '/projects/create'
}

export const createJob = async ({projectType, request}: {projectType: ProjectType, request: NewJobRequest}): Promise<NewJobResponse> => {
  return (await API.post(getPath(projectType), request)).data
}
